import { Dispatch, RefObject, SetStateAction, useState } from 'react';

import { useOnScreen } from '@/common/hooks/useOnScreen/useOnScreen';
import { useImpressionContext } from '@/common/impressions/useImpressionContext';

import { shouldMessageSend, BaseMessage } from './common';

interface UseImpressionsProps<Message> {
  ref: RefObject<Element>;
  message: Message;
  delay?: number;
  threshold?: number;
  initialOnHold?: boolean;
}

interface UseImpressionReturn {
  onHold: boolean;
  setOnHold: Dispatch<SetStateAction<boolean>>;
}
const DEFAULT_THRESHHOLD = 0.5;
const ELEMENT_VISIBILITY_DELAY = 1000;

export const useImpression = <Message extends BaseMessage>({
  ref,
  message,
  delay,
  threshold,
  initialOnHold = false,
}: UseImpressionsProps<Message>): UseImpressionReturn => {
  const worker = useImpressionContext();
  const [onHold, setOnHold] = useState(initialOnHold);

  useOnScreen(ref, {
    threshold: threshold || DEFAULT_THRESHHOLD,
    delay: delay ?? ELEMENT_VISIBILITY_DELAY,
    callback: () => {
      worker && shouldMessageSend(message) && worker.postMessage(message);
    },
    once: true,
    onHold,
  });

  return { onHold, setOnHold };
};
